import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, Button } from '@quadminds/mindkit';
import { MoreHorizontal, Pencil, Trash2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface UserActionsProps<T> {
    user: T;
    onOpenSettings: (item: T) => void;
    disableDelete?: boolean;
    onDelete: (item: T) => void;
    iconSize?: 'sm' | 'default';
    hideSettings?: boolean;
    hideDelete?: boolean;
    deleteLabel?: string;
}

export function UserActions<T>({
    user,
    onOpenSettings,
    onDelete,
    disableDelete,
    hideSettings,
    hideDelete,
    deleteLabel,
}: UserActionsProps<T>) {
    const { t } = useTranslation();
    const buttonSize = 'h-7 w-7';

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button variant="ghost" size="icon" className={buttonSize}>
                    <MoreHorizontal className="h-4 w-4" />
                    <span className="sr-only">{t('modals.fileOptions.actions')}</span>
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
                {!hideSettings && (
                    <DropdownMenuItem onClick={() => onOpenSettings(user)} data-testid="rename-menu-item">
                        <Pencil className="h-4 w-4 mr-1" />
                        Configuracion
                    </DropdownMenuItem>
                )}

                {!hideDelete && (
                    <DropdownMenuItem
                        className="text-destructive"
                        onClick={() => onDelete(user)}
                        data-testid="delete-menu-item"
                        disabled={disableDelete}
                    >
                        <Trash2 className="h-4 w-4 mr-1" />
                        {deleteLabel ?? t('modals.fileOptions.delete')}
                    </DropdownMenuItem>
                )}
            </DropdownMenuContent>
        </DropdownMenu>
    );
}

export default UserActions;
